module.exports = __webpack_public_path__ + "static/img/Fireworks.80a51054.png";